import * as Yup from 'yup';
export var OptionalString = function () { return Yup.string(); };
export var RequiredString = function (message) {
    return OptionalString().required(message || 'Cannot be blank');
};
